import React, { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';

import Index from './components/Index';
import SignIn from './components/pages/auth/SignIn';
import SignUp from './components/pages/auth/SignUp';
import Recovery from './components/pages/auth/Recovery';
import Lgpd from './components/Lgpd';

import ProtectedRoute from './routes/ProtectedRoute';

import Main from './components/layout/Main';
import Home from './components/pages/main/Home';
import Cart from './components/pages/main/Cart';
import Profile from './components/pages/main/Profile';
import Redirect from './components/pages/main/Redirect';
import Logout from './components/pages/main/Logout';
import MyProfile from './components/pages/main/MyProfile';
import Settings from './components/pages/main/Settings';
import SettingsUsers from './components/pages/main/SettingsUsers';
import SettingsBases from './components/pages/main/SettingsBases';
import Bases from './components/pages/main/Bases';
import Search from './components/pages/main/Search';
import Plans from './components/pages/main/Plans';
import Purchase from './components/pages/main/Purchase';
import Payment from './components/pages/main/Payment';
import { ToastProvider } from './context/ToastContext';
import { UserProvider, useUser } from './context/UserContext';
import { PurchaseProvider } from './context/PurchaseContext';
import { CartProvider } from './context/CartContext';
import './App.css';

function App() {
  return (
    <ToastProvider>
      <UserProvider>
        <PurchaseProvider>
          <CartProvider>
            <AppRoutes />
          </CartProvider>
        </PurchaseProvider>
      </UserProvider>
    </ToastProvider>
  );
}

const AppRoutes = () => {
  const { handleLogout } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    let timeout;
    const resetTimeout = () => {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        handleLogout();
        navigate('/');
      }, 900000); // 15 minutos de inatividade
    };

    window.addEventListener('mousemove', resetTimeout);
    window.addEventListener('keypress', resetTimeout);

    resetTimeout(); // Inicializa o timeout

    return () => {
      if (timeout) clearTimeout(timeout);
      window.removeEventListener('mousemove', resetTimeout);
      window.removeEventListener('keypress', resetTimeout);
    };
  }, [navigate, handleLogout]);

  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/lgpd" element={<Lgpd />} />
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/recovery" element={<Recovery />} />
      <Route path="/pages/login" element={<Redirect page='/sign-in' />} />
      <Route path="/pages/register" element={<Redirect page='/sign-up' />} />
      <Route
        path="/main/*"
        element={<ProtectedRoute element={<Main />} />}
      >
        <Route index element={<Home />} />
        <Route path="logout" element={<Logout />} />
        <Route path="my-profile" element={<MyProfile />} />
        <Route path="settings/*" element={<Settings />} >
          <Route path="users" element={<SettingsUsers />} />
          <Route path="bases" element={<SettingsBases />} />
        </Route>
        <Route path="cart" element={<Cart />} />
        <Route path="bases" element={<Bases />} />
        <Route path="search" element={<Search />} />
        <Route path="profile/:userId" element={<Profile />} />
        <Route path="plans" element={<Plans />} />
        <Route path="purchase/:planId" element={<Purchase />} />
        <Route path="payment" element={<Payment />} />
      </Route>
    </Routes>
  );
};

export default App;
